import * as React from 'react';
import Raven from 'raven-js';
import PropTypes from 'prop-types';
import { WithTimelineActionHandlerContext, ADD_REFRESH_ALERT, REMOVE_REFRESH_ALERT } from 'crm-events-data';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * This file is copied from ErrorBoundary in customer-data-objects-ui-components/ErrorBoundary.
 * Usage:
 *   <TimelineErrorBoundary boundaryName="MyComponent_MyError" ErrorComponent={MyError} errorProps={{ foo: 'bar' }}>
 *     <MyComponent />
 *   </TimelineErrorBoundary>
 */
class TimelineErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.attemptToRemount = () => {
      const {
        boundaryName,
        shouldShowRefreshAlert
      } = this.props;
      if (shouldShowRefreshAlert && boundaryName) {
        this.props.handleTimelineAction(ADD_REFRESH_ALERT, {
          boundaryName
        });
        this.props.handleTimelineAction(REMOVE_REFRESH_ALERT, {
          boundaryName
        });
      }
      this.setState({
        hasError: false
      });
    };
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, info = {}) {
    const {
      shouldAutoReset
    } = this.props;
    if (!shouldAutoReset(error)) {
      this.reportErrors(error, info);
    } else {
      this.setState({
        hasError: false
      });
    }
  }

  // Passed to the ErrorComponent to allow for a manual reset of the component.

  reportErrors(error, info = {}) {
    const boundaryName = this.props.boundaryName || '';
    Raven.captureException(error, {
      extra: Object.assign({}, info, {
        version: React.version
      }),
      tags: {
        TimelineErrorBoundaryName: boundaryName
      }
    });
    if (this.props.shouldShowRefreshAlert) {
      this.props.handleTimelineAction(ADD_REFRESH_ALERT, {
        boundaryName
      });
    }
  }
  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    const {
      ErrorComponent
    } = this.props;
    if (this.state.hasError && ErrorComponent) {
      return /*#__PURE__*/_jsx(ErrorComponent, Object.assign({}, this.props.errorProps, {
        attemptToRemount: this.attemptToRemount
      }));
    }
    return null;
  }
}
TimelineErrorBoundary.propTypes = {
  // boundaryName: "<Component>_<Error Component>" (e.g. "FloatingForm_SidebarPropertyError")
  boundaryName: PropTypes.string,
  children: PropTypes.node,
  ErrorComponent: PropTypes.func,
  errorProps: PropTypes.object,
  handleTimelineAction: PropTypes.func,
  /**
   * shouldAutoReset: (optional) attempts to refresh the component and returns a boolean value
   * When false is returned we show and log the error.
   */
  shouldAutoReset: PropTypes.func,
  shouldShowRefreshAlert: PropTypes.bool
};
TimelineErrorBoundary.defaultProps = {
  shouldShowRefreshAlert: true,
  shouldAutoReset: () => false
};
export default WithTimelineActionHandlerContext(TimelineErrorBoundary);

// for testing purposes
export { TimelineErrorBoundary as WrappedComponent };